import { graphql, useStaticQuery } from "gatsby"
import { TNavigation } from "../types"

const ticketLink = (): TNavigation => {

  const query = useStaticQuery(
    graphql`
      query {
        allNavigation(filter: { title: { eq: "Ticket Link" } }) {
          nodes {
            title
            json
          }
        }
      }
    `)

  return query.allNavigation?.nodes[0]

}

export default ticketLink
